import { render, staticRenderFns } from "./CurrencyList.vue?vue&type=template&id=39028047"
import script from "./CurrencyList.vue?vue&type=script&lang=ts"
export * from "./CurrencyList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports